<div mat-subheader>My Projects</div>

@for( project of projects; track project.project_id ) {
<mat-card class="project-card">
  <mat-card-header>
    <mat-card-title>{{ project.title }}</mat-card-title>
    <mat-card-subtitle [innerHTML]="project.description | marked | async"></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <!-- Additional project details can go here -->
  </mat-card-content>
  <mat-card-actions>
    <a mat-button [routerLink]="['/workspace', project.id]" (click)="changeProject(project.id)">Workspace  <mat-icon>build</mat-icon></a>
    <a mat-button [routerLink]="['/stats', project?.id]">Stats  <mat-icon>bar_chart</mat-icon></a>  
    <a mat-button [href]="project.publicationUrl" target="_blank">Distribution  <mat-icon>picture_as_pdf</mat-icon></a>
    @if( project.userRole( user?.user_id || '') === 'admin' ) {
      <a mat-button [routerLink]="['/settings', project.id]">Settings  <mat-icon>settings</mat-icon></a>
      <a mat-button [routerLink]="['/publication/pdf', project.id]">Publication  <mat-icon>publish</mat-icon></a>
    }
    @if( project.userRole( user?.user_id || '') === 'admin' ) {
      <mat-menu #advancedMenu="matMenu">
        <a mat-menu-item [href]="'https://github.com/openreadersbibles/pub-'+project.id" target="_blank">GitHub  <mat-icon>code</mat-icon></a>
        <a mat-menu-item (click)="commonTasks.downloadProjectConfiguration(project)">Project JSON <mat-icon>download</mat-icon></a>
      </mat-menu>
    <button mat-button [matMenuTriggerFor]="advancedMenu">
      Advanced <mat-icon>more_vert</mat-icon>
    </button>
    }
  </mat-card-actions>
</mat-card>
}

@if( projects.length === 0 ) {
    <p>No projects found.</p>
}

<div id="footer">&nbsp;</div>